import subLayoutSourcing from "@/app/common-modules/layout/subLayoutSourcing";
export default [
  {
    // 寻源弹框页面
    path: "/subSourcingFlow",
    component: subLayoutSourcing,
    redirect: "/subSourcingFlow",
    children: [
      {
        path: "/subSourcingFlow",
        component: () =>
          import("@/app/subSourcingFlow/views/subSourcingFlow.vue"),
        name: "subSourcingFlow",
        title: "首页",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpExpertsIn",
        component: () =>
          import("@/app/subSourcingFlow/views/expertsIn/subExpertsIn.vue"),
        name: "scpExpertsIn",
        title: "专家签到",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpExpertSign",
        component: () =>
          import("@/app/subSourcingFlow/views/expertsIn/subExpertSign.vue"),
        name: "scpExpertSign",
        title: "专家重置签名",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpLetterCommitmentConfirm",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/letterCommitmentConfirm/subLetterCommitmentConfirm.vue"
          ),
        name: "scpLetterCommitmentConfirm",
        title: "承诺书确认",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpBidOpenSituation",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/bidOpenSituation/subBidOpenSituation.vue"
          ),
        name: "scpBidOpenSituation",
        title: "开标情况",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/businessBidSituation",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/bidOpenSituation/businessBidSituation.vue"
          ),
        name: "businessBidSituation",
        title: "商务及技术文件开标情况",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/quotationBidSituation",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/bidOpenSituation/quotationBidSituation.vue"
          ),
        name: "quotationBidSituation",
        title: "投标报价文件开标情况",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpScoreScaleDeveloped",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/scoreScaleDeveloped/subScoreScaleDeveloped.vue"
          ),
        name: "scpScoreScaleDeveloped",
        title: "评分表制定",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpViewScoreItems",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/viewScoreItems/subViewScoreItems.vue"
          ),
        name: "scpViewScoreItems",
        title: "评分项查看",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpSupplierComplianceInspection",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/subSupplierComplianceInspection.vue"
          ),
        name: "scpSupplierComplianceInspection",
        title: "初步评审编制",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpSupplierComplianceConfirm",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/subSupplierComplianceConfirm.vue"
          ),
        name: "scpSupplierComplianceConfirm",
        title: "初步评审确认",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpIssueClarificationNotice",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierIssueClarification/subIssueClarificationNotice.vue"
          ),
        name: "scpIssueClarificationNotice",
        title: "发布澄清通知列表",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/businessBidEdit",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/businessBidEdit.vue"
          ),
        name: "businessBidEdit",
        title: "商务及技术文件初步评审编制",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/businessBidDetailEdit",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/businessBidDetailEdit.vue"
          ),
        name: "businessBidDetailEdit",
        title: "商务及技术文件详细评审编制",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/guidePriceScreen",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/bidReportEdit.vue"
          ),
        name: "guidePriceScreen",
        title: "评标基准价筛选",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/businessBidConfirm",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/businessBidConfirm.vue"
          ),
        name: "businessBidConfirm",
        title: "商务及技术文件初步评审确认",
        meta: {
          hide_nav_bar: true
        }
      },

      {
        path: "/businessBidDetailConfirm",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/businessBidDetailConfirm.vue"
          ),
        name: "businessBidDetailConfirm",
        title: "商务及技术文件详细评审确认",
        meta: {
          hide_nav_bar: true
        }
      },

      {
        path: "/quotationBidEdit",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/quotationBidEdit.vue"
          ),
        name: "quotationBidEdit",
        title: "投标报价文件初步评审编制",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/quotationBidConfirm",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierComplianceInspection/quotationBidConfirm.vue"
          ),
        name: "quotationBidConfirm",
        title: "投标报价文件初步评审确认",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpAddIssueClarificationNotice",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierIssueClarification/subAddIssueClarificationNotice.vue"
          ),
        name: "scpAddIssueClarificationNotice",
        title: "发布澄清通知", // 查看澄清通知 // 查看澄清函内容
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpSupplierClarificationLetter",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/supplierIssueClarification/subSupplierClarificationLetter.vue"
          ),
        name: "scpSupplierClarificationLetter",
        title: "分包商澄清函",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpSkiiScore",
        component: () =>
          import("@/app/subSourcingFlow/views/expertEvaluate/subSkiiScore.vue"),
        name: "scpSkiiScore",
        title: "技术评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpAddSkiiScore",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subAddSkiiScore.vue"
          ),
        name: "scpAddSkiiScore",
        title: "新增/编辑技术评分", // 无评分数据
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpSkiiScoreList",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subSkiiScoreList.vue"
          ),
        name: "scpSkiiScoreList",
        title: "技术评分列表", // 已有评分数据
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpCommercialGrade",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subCommercialGrade.vue"
          ),
        name: "scpCommercialGrade",
        title: "商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpAddCommercialGrade",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subAddCommercialGrade.vue"
          ),
        name: "scpAddCommercialGrade",
        title: "新增/编辑商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpAddCommercialGradeNew",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subAddCommercialGradeNew.vue"
          ),
        name: "scpAddCommercialGradeNew",
        title: "新增/编辑商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpCommercialGradeList",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subCommercialGradeList.vue"
          ),
        name: "scpCommercialGradeList",
        title: "商务评分/技术商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpCommercialGradeListNew",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subCommercialGradeListNew.vue"
          ),
        name: "scpCommercialGradeListNew",
        title: "商务评分/技术商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpTechnicalScoreSummary",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subTechnicalScoreSummary.vue"
          ),
        name: "scpTechnicalScoreSummary",
        title: "技术评分汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpSummaryBusinessSkillsScores",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subSummaryBusinessSkillsScores.vue"
          ),
        name: "scpSummaryBusinessSkillsScores",
        title: "商务技术评分汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/businessBidScoreCollect",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/businessBidScoreCollect.vue"
          ),
        name: "businessBidScoreCollect",
        title: "商务及技术文件打分汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpSkillsScores",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subSkillScores.vue"
          ),
        name: "scpSkillsScores",
        title: "打分汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scoreCollect",
        component: () =>
          import("@/app/subSourcingFlow/views/expertEvaluate/scoreCollect.vue"),
        name: "scoreCollect",
        title: "打分汇总新",
        meta: {
          hide_nav_bar: true
        }
      },
      // {
      //   path: "/scoreCollect",
      //   component: () =>
      //     import(
      //       "@/app/subSourcingFlow/views/expertEvaluate/subSkillScores.vue"
      //     ),
      //   name: "scoreCollect",
      //   title: "新版打分汇总",
      //   meta: {
      //     hide_nav_bar: true
      //   }
      // },

      {
        path: "/subSkillScoresZy",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subSkillScoresZy.vue"
          ),
        name: "subSkillScoresZy",
        title: "打分汇总查看",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpOperateSkillOrCommonSummary",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subOperateSkillOrCommonSummary.vue"
          ),
        name: "scpOperateSkillOrCommonSummary",
        title: "技术汇总/商务技术汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpOperateSkillOrCommonSummaryNew",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subOperateSkillOrCommonSummaryNew.vue"
          ),
        name: "scpOperateSkillOrCommonSummaryNew",
        title: "技术及商务打分汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpTechnicalBusinessScore",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/subTechnicalBusinessScore.vue"
          ),
        name: "scpTechnicalBusinessScore",
        title: "技术商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/businessBidScore",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/businessBidScore.vue"
          ),
        name: "businessBidScore",
        title: "商务及技术文件打分",
        meta: {
          hide_nav_bar: true
        }
      },
      // 组长--报价系数抽取
      {
        path: "/coefficientExtract",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/quotedPriceCoefficientExtract.vue"
          ),
        name: "quotedPriceCoefficientExtract",
        title: "报价系数抽取",
        meta: {
          hide_nav_bar: true
        }
      },
      // 组员----报价系数抽取查看
      {
        path: "/coefficientExtract",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/quotedPriceCoefficientExtract.vue"
          ),
        name: "quotedPriceCoefficientView",
        title: "报价系数抽取查看",
        meta: {
          hide_nav_bar: true
        }
      },
      // 组长--报价系数抽取
      {
        path: "/scpSkillsScores802",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/scpSkillsScores802.vue"
          ),
        name: "scpSkillsScores802",
        title: "报价系数抽取新",
        meta: {
          hide_nav_bar: true
        }
      },
      // 组员----报价系数抽取查看
      {
        path: "/scpSkillsScores802",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/expertEvaluate/scpSkillsScores802.vue"
          ),
        name: "scpSkillsScores802View",
        title: "报价系数抽取查看新",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpBidEvaluationReportPreparation",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/bidEvaluationReport/subBidEvaluationReportPreparation.vue"
          ),
        name: "scpBidEvaluationReportPreparation",
        title: "评标报告编制",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpBidEvaluationReportConfirm",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/bidEvaluationReport/subBidEvaluationReportConfirm.vue"
          ),
        name: "scpBidEvaluationReportConfirm",
        title: "评标报告确认",
        meta: {
          hide_nav_bar: true
        }
      },

      {
        path: "/scpBidEvaluationReportPreparation802",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/bidEvaluationReport/subBidEvaluationReportPreparationNew.vue"
          ),
        name: "scpBidEvaluationReportPreparation802",
        title: "评标报告编制新版",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scpBidEvaluationReportConfirm802",
        component: () =>
          import(
            "@/app/subSourcingFlow/views/bidEvaluationReport/subBidEvaluationReportConfirmNew.vue"
          ),
        name: "scpBidEvaluationReportConfirm802",
        title: "评标报告确认新版",
        meta: {
          hide_nav_bar: true
        }
      }
    ]
  }
];
